import { useTranslation } from 'react-i18next';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { RotateCcw } from 'lucide-react';
import type { ReaberturaAtiva } from '@/lib/os-reabertura';

interface ReaberturaBannerProps {
  reabertura: ReaberturaAtiva;
}

/**
 * Banner destacado no detalhe da OS quando ela foi reaberta e está de novo
 * ativa. Mostra o motivo + quem/quando, para o prestador saber o porquê.
 */
export function ReaberturaBanner({ reabertura }: ReaberturaBannerProps) {
  const { t } = useTranslation();
  const dataFmt = format(new Date(reabertura.em), "dd/MM/yyyy 'às' HH:mm", {
    locale: ptBR,
  });
  const autoria = reabertura.por
    ? t('orders.reopenBanner.by', { name: reabertura.por, date: dataFmt })
    : t('orders.reopenBanner.on', { date: dataFmt });

  return (
    <div className="flex items-start gap-3 rounded-lg border border-amber-300 bg-amber-50 p-4 text-amber-900 dark:border-amber-700/60 dark:bg-amber-950/40 dark:text-amber-100">
      <RotateCcw className="h-5 w-5 flex-shrink-0 mt-0.5" />
      <div className="flex flex-col gap-1">
        <p className="font-semibold text-sm">{t('orders.reopenBanner.title')}</p>
        <p className="text-sm whitespace-pre-line">{reabertura.motivo}</p>
        <p className="text-xs opacity-80">{autoria}</p>
      </div>
    </div>
  );
}
